import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { CustomerContextService } from './customer-context.service';

export const customerContextGuard: CanActivateFn = (route, state) => {
  const ctxService = inject(CustomerContextService);
  const router = inject(Router);

  return ctxService.state$.pipe(
    filter(({ initialized }) => initialized),
    map(({ customer }) => !!customer),
    map((isCustomerSet) => {
      if (isCustomerSet) return true;
      if (ctxService.isMultiAccount()) {
        return router.createUrlTree(['context'], {
          queryParams: { return_url: state.url },
        });
      }
      return false;
    }),
  );
};

export const isMultiAccountGuard: CanMatchFn = (route, segments) => {
  const ctxService = inject(CustomerContextService);

  return ctxService.state$.pipe(
    filter(({ initialized }) => initialized),
    map(() => ctxService.isMultiAccount()),
  );
};
